module.exports = __webpack_public_path__ + "img/type2.022f97fd.png";